import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Analysis/Header';
import { useTranslation } from 'react-i18next';
import { getUserProfile } from '../../../helpers/userProfile';
import { useState } from 'react';
import {
  BuildingIcon,
  EvaporatorIcon,
  EnvironmentsIcon,
  LightningIcon,
  DeviceIcon,
  ToolIcon,
  ToolPredictiveIcon,
  SignalIcon,
  WaterIcon,
} from '~/icons/sidebar';

type SidebarIcon = React.ComponentType<{ color?: string; size?: number | string }>;

export const AnalysisLayout = (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const [profile] = useState(getUserProfile);

  const links: {
    title: string,
    link: string,
    isNew?: boolean,
    Icon?: SidebarIcon,
  }[] = [
    {
      title: t('unidades'),
      link: '/analise/unidades',
      Icon: BuildingIcon,
    },
    {
      title: t('manutencao'),
      link: '/analise/manutencao',
      isNew: true,
      Icon: ToolIcon,
    },
    {
      title: t('maquinas'),
      link: '/analise/maquinas',
      Icon: EvaporatorIcon,
    },
  ];

  if (profile.permissions.isAdminSistema) {
    links.push({
      title: t('confortoTermico'),
      link: '/analise/conforto-termico',
      isNew: true,
    });
  }

  links.push(
    {
      title: t('ambientes'),
      link: '/analise/ambientes',
      Icon: EnvironmentsIcon,
    },
    {
      title: t('energia'),
      link: '/analise/energia',
      Icon: LightningIcon,
    },
  );

  if (history.location.pathname.includes('/analise/programacao-dams')) {
    links.push({
      title: t('programacao'),
      link: history.location.pathname + history.location.search,
    });
  }
  links.push({
    title: t('dispositivos'),
    link: '/analise/dispositivos',
    Icon: DeviceIcon,
  });
  links.push({
    title: t('utilitarios'),
    link: '/analise/utilitarios',
    Icon: ToolIcon,
  });
  const isClientToPredictiveDashboard = profile.permissions.PER_CLIENT.some((item) => [145, 149, 152, 136].includes(item.clientId)) && !profile.permissions.isInstaller;
  if (isClientToPredictiveDashboard) {
    links.push({
      title: t('preditivo'),
      link: '/analise/preditivo',
      isNew: true,
      Icon: ToolPredictiveIcon,
    });
  }
  const isClientToWaterDashboard = profile.permissions.PER_CLIENT.some((item) => item.clientId === 152) && !profile.permissions.isInstaller;
  if (isClientToWaterDashboard) {
    links.push({
      title: t('agua'),
      link: '/analise/agua',
      isNew: true,
      Icon: WaterIcon,
    });
  }
  links.push({
    title: t('conectividade'),
    link: '/analise/conectividade',
    Icon: SignalIcon,
  });

  return (
    <Header links={links} />
  );
};

export const AnalysisLayoutGeneral = (): JSX.Element => {
  const { t } = useTranslation();
  const links = [
    {
      title: t('geral'),
      link: '/analise/geral',
    },
    {
      title: t('comparativo'),
      link: '/analise/comparativo',
    },
  ];

  return (
    <Header links={links} />
  );
};
